import * as React from 'react';
const NavCategoryContext = React.createContext(undefined);
const navCategoryContextDefaultValue = {
    open: false,
    value: ''
};
export const { Provider: NavCategoryProvider } = NavCategoryContext;
export const useNavCategoryContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(NavCategoryContext)) !== null && _React_useContext !== void 0 ? _React_useContext : navCategoryContextDefaultValue;
};
